import { useEffect, useState } from "react";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Panel } from "primereact/panel";

import { useReport } from "../../context/report";
import { GraficoSetup } from "../Graficos/GraficoSetup";
import TabelaParadas from "./TabelaParadas";

export function Engrupagens() {
  const [setup, setSetup]  = useState([]);
  const { handlePrint, data, printing } = useReport();

  const format = (rowData, props) => {
    return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(rowData[props.field]);
  }

  useEffect(() => {
    let _setup = [];
    data.setup.forEach((item) => {
      if(_setup.indexOf(item.nome) === -1) {
        _setup.push(item.nome);
      }
    });

    setSetup(_setup);
  }, [data])

  return (
    <div>
      <Panel
        header={"RELATÓRIO DE ENGRUPAGEM/REENGRUPAGEM - " + data.periodo}
        toggleable
      >
        <DataTable
          className="p-m-1"
          filterDisplay="row"
          responsiveLayout="scroll"
          size="small"
          value={data.itens}
        >
          <Column
            header="Data"
            field="dataf"
            filter
            filterField="dataf"
            showFilterMenuOptions={false}
            style={{ width: "15%" }}
          />
          <Column
            header="Turma"
            field="turma"
            filter
            filterField="turma"
            showFilterMenuOptions={false}
            style={{ width: "15%" }}
          />
          <Column
            header="Tear"
            field="tear"
            filter
            filterField="tear"
            showFilterMenuOptions={false}
            style={{ width: "15%" }}
          />
          <Column
            header="Artigo"
            field="artigo"
            filter
            filterField="artigo"
            showFilterMenuOptions={false}
            style={{ width: "15%" }}
          />
          <Column header="Parada" field="parada" />
          <Column header="Tempo" field="tempo" />
        </DataTable>
      </Panel>
      <Panel header="RELATÓRIO DE MÉDIA E METAS DE ENGRUPAGEM" className="p-mt-1" toggleable>
        <DataTable
          className="p-m-1"
          groupRowsBy="turma"
          filterDisplay="row"
          responsiveLayout="scroll"
          rowGroupMode="rowspan"
          size="small"
          value={data.medias}
        >
          <Column
            header="Turma"
            field="turma"
            body={(rowData) => (
              <div style={{ backgroundColor: rowData.cor, height: "100%", margin: 0, padding: 8 }}> 
                <h2 style={{ color: "#000", textAlign: "center" }}>{rowData.turma}</h2>
              </div>
            )}
          />
          <Column
            header="Artigo"
            field="artigo"
            filter
            filterField="artigo"
            showFilterMenuOptions={false}
            style={{ width: "25%" }}
          />
          <Column header="Qtde." field="quantidade" />
          <Column header="Tempo" field="tempo" />
          <Column
            header="Média"
            field="media"
            body={format}
          />
          <Column 
            header="Meta"
            field="media_artigo"
            body={format}
          />
          <Column header="Eficiência" body={(rowData) => {
            return Intl.NumberFormat("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rowData.eficiencia);
          }} />
          <Column 
            header="Situação"
            body={(rowData) => {
              let tempo = rowData.media_artigo - rowData.media
              if(tempo < 0) {
                return (
                  <div style={{ padding: 8, backgroundColor: "#e74c3c", color: "#fff", textAlign: "center" }} >
                    Abaixo
                  </div>
                )
              } else {
                return (
                  <div style={{ padding: 8, backgroundColor: "#2ecc71", color: "#fff", textAlign: "center" }}>
                    Esperado
                  </div>
                )
              }
            }}
            style={{ width: "10%" }}
          />
        </DataTable>
      </Panel>

      {setup.map((element, index) => (
          <>
              <Panel header={`Gráfico de ${element}`} key={`setup${index}`} className="p-mt-1" toggleable collapsed>
                  <Button className="p-m-2" icon="pi pi-print" onClick={() => handlePrint(`GraficoSetup${index}`)} />
                  <GraficoSetup data={data} type={element} printing={printing} index={index} />
              </Panel>
          </>
      ))}

      <Panel header='Geral' className="p-mt-1" toggleable collapsed>
        <TabelaParadas
          data={data} 
          geral={true}
          name='relatorio'
        />
      </Panel>
    </div>
  );
}
